import React from 'react';
import type { LucideIcon } from 'lucide-react';

/**
 * Felles overskrift for panelene på produksjonssiden (Produksjonsplan,
 * Bemanning, Oppmøtetider, Varslingsstatus). Én kilde så de ikke driver fra hverandre.
 */
interface SectionTitleProps {
  icon: LucideIcon;
  children: React.ReactNode;
}

const SectionTitle: React.FC<SectionTitleProps> = ({ icon: Icon, children }) => (
  <div className="flex items-center gap-2 sm:gap-3">
    <Icon className="h-5 w-5 sm:h-6 sm:w-6 text-primary" aria-hidden="true" />
    <h2 className="text-xl sm:text-2xl font-bold text-foreground">{children}</h2>
  </div>
);

export default SectionTitle;
